export const en = {
    at: 'at',
    'at-percent': 'by {conversionInput}%',
    down: 'decrease',
    max: 'max',
    min: 'min',
    up: 'increase'
};
